import { formatCurrency } from '../utils/utils';

const MoneyDisplay = ({ amount, language }) => {
  const formattedAmount = formatCurrency(amount, language);

  return <>{formattedAmount}</>;
};

export default MoneyDisplay;